import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from 'components/Button';
import Dialog from '@material-ui/core/Dialog';
import TextField from 'components/TextField';
import { saveVendorReferenceData } from 'actions/orders';
import {
  VendorModalContainer,
  Footer,
} from 'styles/pages/my-stores/registration';

const VendorReferenceDialog = ({ open, hideModal, selectedOrders, reload }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state?.auth?.profile?.emailid);
  const [value, setValue] = useState('');

  return (
    <Dialog maxWidth="md" open={open} onClose={() => hideModal()}>
      <VendorModalContainer>
        <h1>Vendor Reference</h1>
        <h3>
          Please enter scheduled Vendor's Reference or Tracking Number for the
          following orders
        </h3>

        <div style={{ marginBottom: 30 }}>
          <ul>
            {selectedOrders?.map((o) => (
              <li key={o?.ReceiptID}>
                {o?.ReceiptID}&nbsp;
                <b>({o?.OrderLines[0]?.shopifyOrderPresentedID})</b>
              </li>
            ))}
          </ul>
        </div>

        <TextField
          style={{ width: '100%' }}
          size="small"
          label={`Vendor's Reference / Tracking Number`}
          value={value}
          onChange={(v) => setValue(v)}
        />

        <Footer>
          <Button
            variant="text"
            title="Save"
            onClick={async () => {
              const payload = {
                user,
                vendorReferenceNumber: value || '',
                orders: selectedOrders.map((o) => o?.ReceiptID),
              };

              await dispatch(saveVendorReferenceData(payload));
              reload();
            }}
          />
        </Footer>
      </VendorModalContainer>
    </Dialog>
  );
};

export default VendorReferenceDialog;
